import LoadingLogo from '@/components/atoms/LoadingLogo';
import ProvidersGridSkeleton from '@/components/molecules/Skeletons/ProvidersGridSkeleton';
import { MAX_CONTAINER_WIDTH } from '@/constants/dimensions';
import { HStack, Text, VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

type Props = {
  title: string;
  isLoading?: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  onViewMoreClick?: () => void;
};

const DirectoryPageTemplate = ({
  title,
  children,
  isLoading = false,
  isFetchingNextPage = false,
  hasNextPage = false,
  onViewMoreClick = () => {},
}: PropsWithChildren<Props>) => {
  return (
    <VStack width={MAX_CONTAINER_WIDTH} paddingBottom={'40px'}>
      <Text variant={'loraTitle'}>{title}</Text>
      {isLoading && (
        <VStack marginTop={'56px'}>
          <ProvidersGridSkeleton />
        </VStack>
      )}
      {!isLoading && (
        <VStack width={'100%'}>
          <HStack gap={'20px'} width={'100%'} wrap={'wrap'} marginTop={'110px'} rowGap={'80px'} justify={'center'}>
            {children}
          </HStack>
          {hasNextPage && !isFetchingNextPage && (
            <HStack cursor={'pointer'} onClick={onViewMoreClick} marginY={'30px'}>
              <Text
                variant={'urbanistSemiBoldSmallTitle'}
                cursor={'pointer'}
                _hover={{ opacity: 0.7 }}
                color={'primary.500'}
                fontSize="18px"
              >
                View More
              </Text>
            </HStack>
          )}

          {isFetchingNextPage && (
            <HStack paddingY={'20px'} marginTop={'40px'}>
              <LoadingLogo spacing="16px" width="100px" spinnerSize="48px" />
            </HStack>
          )}
        </VStack>
      )}
    </VStack>
  );
};

export default DirectoryPageTemplate;
